<template>
  <span
    :class="classes"
    v-text="texte">
  </span>
</template>

<script>

export default {
  name: 'DiffPourcentage',
  props: {
    val1: Number,
    val2: Number
  },
  computed: {
    differenceNum() {
      if(this.val1 == this.val2)
        return 0;
      if(this.val1 == 0) // nouvelle valeur, pour éviter div par zéro
        return 100;
      return 100*(this.val2-this.val1)/this.val1;
    },
    texte() {
      if(this.val1 == this.val2)
        return "";
      if(this.val1 == 0)
        return "Nouvelle valeur";
      return this.differenceNum.toFixed(1)+"%";
    },
    classes() {
      if(this.val1 == this.val2)
        return "";
      if(this.val1 == 0)
        return "badge badge-primary";
      if(Math.abs(this.differenceNum) >= 25)
        return "badge badge-danger";
      if(Math.abs(this.differenceNum) >= 10)
        return "badge badge-warning";
      return "badge badge-secondary";
    }
  }
}

</script>
